import React from 'react';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import SectionTitle from '../SectionTitle';
import FormSection from './FormSection';
import CheckBoxesForPardesHannaKarkur from '../../../../features/checkBoxesForPardesHannaKarkur/CheckBoxesForPardesHannaKarkur';
import SelectStreet from '../../../../components/form/selects/SelectStreet';
import InputGroup from '../../../../components/form/InputGroup';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../hooks/useTags';
import formErrorsLang from '../../../../data/lang/form-errors.lang';

function ContactDetailsFormSection() {
    
    const { handleChange, Formik, houseAndAppDes, streetDes, setStreetDes, 
        sethouseAndAppDes, handleOnChangeStreet } = usePermitRequestContext();

    const { errors, values, touched, handleBlur, setFieldValue, setFieldTouched } = Formik;
    const contactDetails = values.contactDetails;
    const contaDetailsErrors = errors.contactDetails ? errors.contactDetails : {};
    const contaDetailsTouched = touched.contactDetails ? touched.contactDetails : {};

    const generateTag = useTags();

    const sectionTitle = generateTag(addRequestPageLang, 'form.contact-details-section.title');
    const houseLabel = generateTag(addRequestPageLang, 'form.contact-details-section.houseLabel');
    const apartmentLabel = generateTag(addRequestPageLang, 'form.contact-details-section.apartmentLabel');
    const emailLabel = generateTag(addRequestPageLang, 'form.contact-details-section.emailLabel');
    const mobileLabel = generateTag(addRequestPageLang, 'form.contact-details-section.mobileLabel');
    const phoneLabel = generateTag(addRequestPageLang, 'form.contact-details-section.phoneLabel');

    const streetIdTouched = contaDetailsTouched.streetId;
    const streetIdError = contaDetailsErrors.streetId;
    const streetIdMsg = generateTag(formErrorsLang, streetIdError && streetIdTouched ? streetIdError : '');

    const houseTouched = contaDetailsTouched.house;
    const houseError = contaDetailsErrors.house;
    const houseMsg = generateTag(formErrorsLang, houseError && houseTouched ? houseError : '');

    const apartmentTouched = contaDetailsTouched.appartment;
    const apartmentError = contaDetailsErrors.appartment;
    const apartmentMsg = generateTag(formErrorsLang, apartmentError && apartmentTouched ? apartmentError : '');

    const emailTouched = contaDetailsTouched.email;
    const emailError = contaDetailsErrors.email;
    const emailMsg = generateTag(formErrorsLang, emailError && emailTouched ? emailError : '');

    const mobileTouched = contaDetailsTouched.mobile;
    const mobileError = contaDetailsErrors.mobile;
    const mobileMsg = generateTag(formErrorsLang, mobileError && mobileTouched ? mobileError : '');

    const phoneTouched = contaDetailsTouched.phone;
    const phoneError = contaDetailsErrors.phone;
    const phoneMsg = generateTag(formErrorsLang, phoneError && phoneTouched ? phoneError : '');

    

    return (
        <FormSection>
            <SectionTitle title={sectionTitle} />

            <CheckBoxesForPardesHannaKarkur
                setFieldValue={setFieldValue}
                setStreetDes={setStreetDes}
                sethouseAndAppDes={sethouseAndAppDes}
                handleOnChangeStreet={handleOnChangeStreet}
                extra4Map={values.extra4}
            />

            <div className='row'>
                <div className='col-6 col-md-6 col-lg-4'>
                    <SelectStreet
                        name={'streetId'}
                        value={Number(contactDetails.streetId)}
                        isRequired={true}
                        disabled={streetDes}
                        handleChange={(_, val) => handleOnChangeStreet(val)}
                        handleBlur={(e) => {
                            handleBlur(e);
                            setFieldTouched('contactDetails.streetId', true);
                        }}
                        errorMsg={streetIdMsg}
                    />
                </div>

                <div className='col-3 col-md-3 col-lg-2'>
                    <InputGroup
                        name={'contactDetails.house'}
                        type='number'
                        label={houseLabel}
                        value={contactDetails.house}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        disabled={houseAndAppDes}
                        isRequired={true}
                        errorMsg={houseMsg}
                    />
                </div>
                <div className='col-3 col-md-3 col-lg-2'>
                    <InputGroup
                        name={'contactDetails.appartment'}
                        label={apartmentLabel}
                        value={contactDetails.appartment}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        disabled={houseAndAppDes}
                        errorMsg={apartmentMsg}
                    />
                </div>
            </div>

            <div className='row'>
                <div className='col-md-6 col-lg-4'>
                    <InputGroup
                        name={'contactDetails.email'}
                        label={emailLabel}
                        value={contactDetails.email}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={emailMsg}
                    />
                </div>
            </div>

            <div className='row'>
                <div className='col-6 col-lg-3'>
                    <InputGroup
                        name={'contactDetails.mobile'}
                        label={mobileLabel}
                        value={contactDetails.mobile}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={mobileMsg}
                    />
                </div>
                <div className='col-6 col-lg-3'>
                    <InputGroup
                        name={'contactDetails.phone'}
                        label={phoneLabel}
                        value={contactDetails.phone}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        errorMsg={phoneMsg}
                    />
                </div>
            </div>
        </FormSection>
    );
}

export default ContactDetailsFormSection;